import React from 'react';

const DoctorsHero = () => {
  return (
    <div className="bg-gradient-to-r from-[#0760ad] to-[#098a48] py-20 px-4 sm:px-6 lg:px-8 text-center">
      <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Our Expert Doctors</h1>
      <p className="text-xl text-blue-100 max-w-3xl mx-auto">
        Meet our team of highly qualified specialists dedicated to your health and wellbeing
      </p>
    </div>
  );
};

export default DoctorsHero;